document.addEventListener('DOMContentLoaded', function(){
  let btnWrapper = document.querySelector('.product-info__add-button');
  let btn = btnWrapper.querySelector('button');
  let optionValue = document.querySelector('.custom-select__btn .text-start').dataset.option;

  const handleClick = () => {
    alert("Vennligst velg "+ optionValue + " først");
  };

  if(btn.disabled){
    btnWrapper.classList.add('disabled_select');
    btnWrapper.addEventListener('click', handleClick);
    
   
  }

  let customSelectOptions = document.querySelectorAll('.custom-select__option');
  customSelectOptions.forEach((customSelectOption) => {
    customSelectOption.addEventListener('click', () => {
      if(btn.disabled){
        btnWrapper.classList.remove('disabled_select');
        btnWrapper.removeEventListener('click', handleClick);
      }   
    })
  })
  let customAddToCart = document.querySelector('.custom-select__btn .text-start').dataset.text;
  let buyBtnDisabledWrapper = document.querySelector('.product-info__add-button');
  let buyBtnDisabled = buyBtnDisabledWrapper.querySelector('button');
  
  window.onload = () => {
    buyBtnDisabled.innerHTML = customAddToCart;
  } 
})
